var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h3',[_vm._v(" 最近作った会話デッキ "),_c('span',{staticClass:"subtitle-1"},[_vm._v("(*ブラウザのキャッシュを削除すると消えます)")])]),_c('DeckList',{attrs:{"decks":_vm.decks},on:{"select-deck":function($event){return _vm.selectDeck($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }